import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=e64a1606&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=e64a1606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64a1606",
  null
  
)

export default component.exports